import React from "react";
import PropTypes from "prop-types";

import BreadcrumbList from "components/search/Breadcrumbs/BreadcrumbList";
import FacilityBreadcrumbSchema from "components/search/Breadcrumbs/FacilityBreadcrumbSchema";
import { useSelector } from "react-redux";
import { Button } from "components/core/Button";
import { Chevron } from "components/core/Icons";
import navigate from "utils/navigate";
import { useMediaQuery, mediaQueries } from "hooks/useMediaQuery";


import "./Breadcrumbs.scss";

const Breadcrumbs = ({
	cityUrl,
	stateUrl,
	location,
	facilityUrl,
	allowTruncation,
	facilityName
}) => {
	const baseUrl = useSelector((s) => s?.app?.baseUrl) || "https://www.storage.com";
	const { state, fullState, preferredPlaceName } = location;

	const breadcrumbs = [
		{
			label: "Home",
			href: "/"
		},
		{
			label: "Find Storage",
			href: "/self-storage"
		}
	];

	if (stateUrl) {
		breadcrumbs.push({
			label: fullState,
			name: state,
			href: stateUrl
		});
	}

	if (cityUrl) {
		breadcrumbs.push({
			label: preferredPlaceName,
			name: preferredPlaceName,
			href: cityUrl
		});
	}

	if (facilityUrl) {
		breadcrumbs.push({
			label: facilityName,
			name: facilityName,
			href: facilityUrl
		});
	}

const [belowMedium] = useMediaQuery([mediaQueries.belowMedium]);


	const previousBreadcrumb =
		breadcrumbs[breadcrumbs.length - 2] || breadcrumbs[0];

	const handleBackButtonClick = (previousBreadcrumbHref) => {
		navigate(previousBreadcrumbHref);
	};

	return (
		<div className="breadcrumbs-v2">
			<>
				{belowMedium ? <Button
					theme="basic"
					onClick={() =>
						handleBackButtonClick(previousBreadcrumb.href)
					}
					className="back-button-v2"
					title={`Navigate to ${previousBreadcrumb.label}`}
				>
					<Chevron
						fill="blue"
						rotate="left"
					/>
					<span>Back</span>
				</Button> : <BreadcrumbList
					variant="v2"
					breadcrumbs={breadcrumbs}
					allowTruncation={allowTruncation}
				/>}


			</>
			<FacilityBreadcrumbSchema
				baseUrl={baseUrl}
				stateUrl={stateUrl}
				cityUrl={cityUrl}
				facilityUrl={facilityUrl}
				facilityName={facilityName}
				state={fullState}
				city={preferredPlaceName}
			/>
		</div>
	);
};

Breadcrumbs.defaultProps = {
	cityUrl: "",
	location: {},
	stateUrl: "",
	facilityUrl: "",
	allowTruncation: false,
	facilityName: ""
};

Breadcrumbs.propTypes = {
	cityUrl: PropTypes.string,
	location: PropTypes.object,
	stateUrl: PropTypes.string,
	facilityUrl: PropTypes.string,
	allowTruncation: PropTypes.bool,
	facilityName: PropTypes.string
};

export default Breadcrumbs;
